import React from "react";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import MoveButton from "components/Flow/Tabs/ItemMovementTabs/MoveButton";
import DiscipleshipAddPeopleButton from "./DiscipleshipAddPeopleButton";
import DiscipleshipRemovePeopleButton from "./DiscipleshipRemovePeopleButton";

interface DiscipleshipPeopleControlPanelProps {
  inputFunctionalities: any[];
  outputFunctionalities: any[];

  selectedInputID: string;
  selectedOutputID: string;

  setSelectedInput: (id: string) => void;
  setSelectedOutput: (id: string) => void;

  handleMove: (direction: "forward" | "backward") => void;

  nodeData: any;
  items: any[];
  selectedItems: any[];
  refreshItems: () => void;

  inputTypeField?: string;
  outputTypeField?: string;
  inputLabelField?: string;
  outputLabelField?: string;
  disabled?: boolean;
}

const DiscipleshipPeopleControlPanel: React.FC<
  DiscipleshipPeopleControlPanelProps
> = ({
  inputFunctionalities,
  outputFunctionalities,
  selectedInputID,
  selectedOutputID,
  setSelectedInput,
  setSelectedOutput,
  handleMove,
  nodeData,
  items,
  selectedItems,
  refreshItems,
  inputTypeField,
  outputTypeField,
  inputLabelField,
  outputLabelField,
  disabled = false,
}) => {
  return (
    <Box>
      <Grid2 container>
        <Grid2 size={4} alignItems="left">
          <MoveButton
            direction="backward"
            label="Input Source"
            functionalities={inputFunctionalities}
            selectedID={selectedInputID}
            onSelectChange={setSelectedInput}
            onMoveClick={() => handleMove("backward")}
            inputTypeField={inputTypeField}
            inputLabelField={inputLabelField}
            disabled={disabled}
          />
        </Grid2>

        <Grid2 size={2} alignItems="center">
          <DiscipleshipAddPeopleButton
            nodeData={nodeData}
            currentItems={items}
            onAdded={refreshItems}
            disabled={disabled}
          />
        </Grid2>

        <Grid2 size={2} alignItems="center">
          <DiscipleshipRemovePeopleButton
            selectedItems={selectedItems}
            onRemoved={refreshItems}
            disabled={disabled}
          />
        </Grid2>

        <Grid2 size={4} alignItems="right">
          <MoveButton
            direction="forward"
            label="Output Target"
            functionalities={outputFunctionalities}
            selectedID={selectedOutputID}
            onSelectChange={setSelectedOutput}
            onMoveClick={() => handleMove("forward")}
            outputTypeField={outputTypeField}
            outputLabelField={outputLabelField}
            disabled={disabled}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default DiscipleshipPeopleControlPanel;